import { WEAVR_NAME_ON_CARD_REGEX } from "@finway-group/shared/lib/consts"
import { WEAVR_NAME_ON_CARD_MAX_LENGTH } from "@finway-group/shared/lib/consts/weavr"
import { Rule } from "antd/lib/form"
import { parseCurrencyInput } from "~Components/currencyInput/config"
import { stringRules } from "~Components/forms/rules/common/string.rules"
import { i18n } from "~Shared/locales/i18n"
import { isEmptyString } from "~Shared/utils/helper.utils"

export const createCreditCardRules = () => ({
    cardHolder: [
        {
            required: true,
            message: i18n.t("validation:required"),
        },
    ] as Array<Rule>,
    limit: [
        {
            validator: (_rule, inputValue: string) => {
                let value = 0
                inputValue = inputValue ? inputValue.toString() : ""
                if (inputValue !== "") {
                    value = parseCurrencyInput(inputValue)
                    if (value <= 0) {
                        return Promise.reject(new Error(i18n.t("validation:greater.number_short", { min: 0 })))
                    }

                    return Promise.resolve()
                }

                return Promise.reject(new Error(i18n.t("validation:greater.number_short", { min: 0 })))
            },
        },
    ] as Array<Rule>,
    window: [
        {
            required: true,
            message: i18n.t("validation:required"),
        },
    ] as Array<Rule>,
    card: [
        {
            required: true,
            message: i18n.t("validation:required"),
        },
    ] as Array<Rule>,
    cardName: [
        {
            validator: (_rule, inputValue: string) => {
                if (isEmptyString(inputValue)) {
                    return Promise.reject(i18n.t("validation:required"))
                }
                if (inputValue.length > 50) {
                    return Promise.reject(new Error(i18n.t("validation:below.string", { max: 50 })))
                }

                return Promise.resolve()
            },
        },
        stringRules.allowedMultiLineCharsOnly,
    ] as Array<Rule>,
    nameOnCard: [
        {
            validator: (_rule, value: string) => {
                if (isEmptyString(value)) {
                    return Promise.reject(i18n.t("validation:required"))
                }

                if (!WEAVR_NAME_ON_CARD_REGEX.test(value)) {
                    return Promise.reject(new Error(i18n.t("validation:only_letters_including_umlauts")))
                }

                if (value.length > WEAVR_NAME_ON_CARD_MAX_LENGTH) {
                    return Promise.reject(new Error(i18n.t("validation:below.string", { max: WEAVR_NAME_ON_CARD_MAX_LENGTH })))
                }

                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})
